export const FETCH_SOLAR_PRODUCT_PAGE = "fetchSolarProductPage";
export const FETCH_BATTERIES_PRODUCT_PAGE = "fetchBatteriesProductPage";
export const FETCH_PRODUCT_RESOURCE = "fetchProductResource";
